import styled from 'styled-components';

export const HelpText = styled.div`
  border: 1px solid ${({ theme }) => theme.color.secondaryButtonBorder};
  background-color: ${({ theme }) => theme.color.disabledButtonBackground};
  padding: ${({ theme }) => theme.space.md};
  margin-top: ${({ theme }) => theme.space.xs};
  margin-bottom: ${({ theme }) => theme.space.xs};
`;
